import { black, white } from '../assets/style/colors';
import { MainNavProps } from './navigation/main/MainParamList';
import FastImage, { OnLoadEvent } from 'react-native-fast-image';
import { StyleSheet, Text, View } from 'react-native';
import { useWindowDimensions } from 'react-native';
import ViewZoom from '../components/image-zoom/ViewZoom';
import React, { useEffect, useState } from 'react';
// Immerse related imports removed for web compatibility
import { Str_LoadFail } from '../language/string_res';
import { ImageView } from '../components/ImageView';
import { saveAsset, saveImageToPhoto } from '../utils/FileUtils';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { AnimatedCircularProgress } from 'react-native-circular-progress';

export function ImageScreen({ navigation, route }: MainNavProps<'ImageScreen'>) {
	const { width: screenWidth, height: screenHeight } = useWindowDimensions();
	const imgUrl = route.params.item.content;
	const localPath = route.params.item.upload_path || route.params.item.thumbnailPath;

	const [size, setSize] = useState([0, 0]);
	const [loadState, setLoadState] = useState<'loading' | 'success' | 'failure'>('loading');
	const [loaclLoadError, setLoaclLoadError] = useState(false);
	const insets = useSafeAreaInsets();
	const [progress, setProgress] = useState(0);

	// Immerse related code removed for web compatibility

	const onLoad = (event: OnLoadEvent) => {
		const { width, height } = event.nativeEvent;
		if (width !== size[0] || height != size[1]) {
			setSize([width, height]);
		}
	};

	const handleLoadStart = () => {
		setLoadState('loading');
	};

	const handleLoadEnd = () => {
		setLoadState('success');
	};

	const handleError = () => {
		setLoadState('failure');
	};

	const handleLoaclLoadError = () => {
		//无论成功或失败都会onLoadEnd,
		setLoaclLoadError(true);
	};
	const handleLoadProgress = (event: any) => {
		const loaded = event.nativeEvent.loaded || 0;
		const total = event.nativeEvent.total || 1;
		setProgress((loaded / total) * 100);
	};

	let width = size[0];
	let height = size[1];
	width = screenWidth;
	height = screenHeight;

	const saveImage = () => {
		if (localPath && !loaclLoadError) {
			saveAsset(localPath);
		} else {
			saveImageToPhoto(imgUrl);
		}
	};

	return (
		<View style={style.container}>
			<View style={style.contentContainer}>
				<ViewZoom
					cropWidth={width}
					cropHeight={height}
					imageWidth={width}
					imageHeight={height}
					enableDoubleClickZoom={true}
					onClick={() => {
						navigation.goBack();
					}}
					panToMove={true}
					swipeDownThreshold={100}
					enableSwipeDown={false}
				>
					<View style={{ width: width, height: height }}>
						{(loaclLoadError === true || (localPath?.length ?? 0) == 0) && (
							<FastImage
								style={{ width: width, height: height }}
								resizeMode={'contain'}
								onLoad={onLoad}
								onLoadEnd={handleLoadEnd}
								onError={handleError}
								onLoadStart={handleLoadStart}
								onProgress={handleLoadProgress}
								source={{
									uri: imgUrl,
									priority: FastImage.priority.normal, // 优先级
									cache: FastImage.cacheControl.immutable, // 缓存策略
								}}
							/>
						)}

						{loaclLoadError !== true && (localPath?.length ?? 0) > 0 && (
							<FastImage
								style={{ width: width, height: height, position: 'absolute' }}
								resizeMode={'contain'}
								onLoad={onLoad}
								onError={handleLoaclLoadError}
								source={{ uri: localPath }}
							/>
						)}
					</View>
				</ViewZoom>

				{loadState === 'failure' && imgUrl.length > 0 && loaclLoadError && (
					<View style={style.overlayContainer}>
						<Text style={{ color: white, fontSize: 24 }}>{Str_LoadFail}</Text>
					</View>
				)}
				{loadState === 'loading' && (
					<View style={style.overlayContainer}>
						<AnimatedCircularProgress
							size={80} // 圆的直径
							width={8} // 圆环的宽度
							rotation={0} // 旋转角度（0 表示从顶部开始）
							fill={progress} // 填充的百分比
							// backgroundColor="#e0e0e0" // 背景条颜色
							duration={10} // 动画持续时间
							tintColor={white}
						/>
					</View>
				)}
			</View>
			<View style={[style.bottomContainer, { bottom: insets.bottom + 30 }]}>
				<ImageView
					onClick={() => navigation.goBack()}
					style={style.backStyle}
					imgStyle={{ width: 24, height: 24 }}
					source={require('../assets/image/guanbi.png')}
				/>
				<ImageView
					onClick={saveImage}
					style={style.backStyle}
					imgStyle={{ width: 24, height: 24 }}
					source={require('../assets/image/icon_download.png')}
				/>
			</View>
		</View>
	);
}

const style = StyleSheet.create({
	container: {
		backgroundColor: black,
		position: 'absolute',
		top: 0,
		bottom: 0,
		start: 0,
		end: 0,
		alignItems: 'center',
		justifyContent: 'center',
	},
	contentContainer: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		start: 0,
		end: 0,
		alignItems: 'center',
		justifyContent: 'center',
	},
	bottomContainer: {
		position: 'absolute',
		start: 0,
		end: 0,
		flexDirection: 'row',
	},
	overlayContainer: {
		...StyleSheet.absoluteFillObject,
		alignItems: 'center',
		justifyContent: 'center',
	},
	backStyle: {
		backgroundColor: 'rgba(0,0,0,0.4)',
		borderRadius: 50,
		width: 40,
		height: 40,
		justifyContent: 'center',
		alignItems: 'center',
		marginStart: 20,
	},
});
